'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimationAccent = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Accent = require('./Accent');

var _Accent2 = _interopRequireDefault(_Accent);

var _styles = require('@material-ui/core/styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = React.createElement(_Accent2.default, null);

var AnimationAccent = exports.AnimationAccent = function (_React$Component) {
  (0, _inherits3.default)(AnimationAccent, _React$Component);

  function AnimationAccent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AnimationAccent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AnimationAccent.__proto__ || (0, _getPrototypeOf2.default)(AnimationAccent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      left: NaN,
      width: NaN
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AnimationAccent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var from = nextProps.from,
          isAnimating = nextProps.isAnimating,
          _nextProps$offset = nextProps.offset,
          offset = _nextProps$offset === undefined ? 0 : _nextProps$offset,
          to = nextProps.to;


      if (from && from.left && from.width) {
        this.setState({
          left: from.left + offset * -1,
          width: from.width
        });
      }

      if (isAnimating) {
        window.requestAnimationFrame(function () {
          if (to && to.left && to.width) {
            _this2.setState({
              left: to.left + offset * -1,
              width: to.width
            });
          }

          setTimeout(function () {
            _this2.props.onAnimationEnd();
          }, 200);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          isAnimating = _props.isAnimating;
      var _state = this.state,
          left = _state.left,
          width = _state.width;


      var styles = {
        opacity: isAnimating ? 1 : 0
      };

      if (!isNaN(left)) {
        styles.left = left;
      }

      if (!isNaN(width)) {
        styles.width = width;
      }

      return React.createElement(
        'div',
        {
          className: classes.wrapper,
          style: styles
        },
        _ref2
      );
    }
  }]);
  return AnimationAccent;
}(React.Component);

AnimationAccent.defaultProps = {
  classes: {}
};


var styleSheet = function styleSheet(_ref3) {
  var transitions = _ref3.transitions;
  return {
    wrapper: {
      bottom: 0,
      position: 'absolute',
      transition: '\n      left ' + transitions.duration.shortest + 'ms ' + transitions.easing.sharp + ',\n      width ' + transitions.duration.shortest + 'ms ' + transitions.easing.sharp + '\n    ',
      willChange: 'left, width'
    }
  };
};

exports.default = (0, _styles.withStyles)(styleSheet)(AnimationAccent);